// extracted by mini-css-extract-plugin
export default {"header":"Table_header__z8uud","link":"Table_link__JgJdU","active":"Table_active__axV+f","inactive":"Table_inactive__9FnNV"};